





import { Vue, Component } from 'vue-property-decorator';
import { SHOPBY_HELP_URL } from '@/const/url';

@Component({})
export default class ShopByGuideButton extends Vue {
  private openGuide() {
    window.open(SHOPBY_HELP_URL, '_blank', 'noopener,noreferrer');
  }
}
